export const PersistedStateCheckout = {
  ProductId: 'product_id',
} as const
